import React from 'react';
import PropTypes from 'prop-types';
import {
  BasicModal,
  CloseButton,
} from '@makeably/creativex-design-system';
import AssetImage from 'components/molecules/AssetImage';
import styles from './CampaignAssetsModal.module.css';

const propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    videoLength: PropTypes.number,
  })),
  isOpen: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  assets: [],
};

function renderEmptyAssets() {
  return (
    <div className={`u-flexRow u-justifyCenter u-alignCenter t-empty ${styles.empty}`}>
      This campaign has no assets to display at this time
    </div>
  );
}

function renderAssets(assets) {
  if (assets.length === 0) {
    return renderEmptyAssets();
  }

  return (
    <div className="u-flexRow u-justifyCenter u-gap-24">
      { assets.map((asset) => (
        <div key={asset.url} className={styles.assetPreview}>
          <AssetImage
            alt="Asset Preview"
            src={asset.url}
            videoLength={asset.videoLength}
          />
        </div>
      )) }
    </div>
  );
}

function CampaignAssetsModal({
  assets,
  isOpen,
  name,
  onClose,
}) {
  return (
    <BasicModal
      isOpen={isOpen}
      size="medium"
      onClose={onClose}
    >
      <div className="u-flexColumn u-gap-16">
        <div className="u-flexRow u-justifyBetween">
          <div className="u-flexColumn u-gap-8">
            <h4>Assets Preview</h4>
            <div className="t-subtitle">
              { name }
            </div>
          </div>
          <CloseButton onClick={onClose} />
        </div>
        { renderAssets(assets) }
      </div>
    </BasicModal>
  );
}

CampaignAssetsModal.propTypes = propTypes;
CampaignAssetsModal.defaultProps = defaultProps;

export default CampaignAssetsModal;
